export enum UserPermissionName {
  // Customer
  VIEW_CUSTOMER = 'View Customer', //PermissionName
  ADD_CUSTOMER = 'Add Customer',
  EDIT_CUSTOMER = 'Edit Customer',
  DELETE_CUSTOMER = 'Delete Customer',

  VIEW_SERVICE_CUSTOMER = 'View Service Customer',
  ADD_SERVICE_CUSTOMER = 'Add Service Customer',
  DELETE_SERVICE_CUSTOMER = 'Delete Service Customer',
  EDIT_SREVICE_PRICE_CUSTOMER = 'Edit Service Price Customer',

  VIEW_CONTRACT_CUSTOMER = 'View Contract Customer',
  DOWNLOAD_CONTRACT_CUSTOMER = 'Download Contract Customer',

  VIEW_CONTACTS_CUSTOMER = 'View Contacts Customer',
  ADD_CONTACTS_CUSTOMER = 'Add Contacts Customer',
  EDIT_CONTACTS_CUSTOMER = 'Edit Contacts Customer',
  DELETE_CONTACTS_CUSTOMER = 'Delete Contacts Customer',

  VIEW_FILES_CUSTOMER = 'View File Customer',
  UPLOAD_FILES_CUSTOMER = 'Upload File Customer',
  EDIT_FILES_CUSTOMER = 'Edit File Customer',
  DELETE_FILES_CUSTOMER = 'Delete File Customer',
  DOWNLOAD_FILES_CUSTOMER = 'Download File Customer',

  VIEW_NOTE_CUSTOMER = 'View Note Customer',
  ADD_NOTE_CUSTOMER = 'Add Note Customer',
  EDIT_NOTE_CUSTOMER = 'Edit Note Customer',
  DELETE_NOTE_CUSTOMER = 'Delete Note Customer',

  //Office
  VIEW_OFFICE = 'View Office',
  ADD_OFFICE = 'Add Office',
  EDIT_OFFICE = 'Edit Office',
  //DELETE_OFFICE = 'Delete Office',

  VIEW_SERVICE_OFFICE = 'View Service Office',
  ADD_SERVICE_OFFICE = 'Add Service Office',
  DELETE_SERVICE_OFFICE = 'Delete Service Office',
  EDIT_SREVICE_PRICE_OFFICE = 'Edit Service Price Office',

  VIEW_CONTRACT_OFFICE = 'View Contract Office',
  ADD_CONTRACT_OFFICE = 'Add Contract Office',
  EDIT_CONTRACT_OFFICE = 'Edit Contract Office',
  DELETE_CONTRACT_OFFICE = 'Delete Contract Office',
  DOWNLOAD_CONTRACT_OFFICE = 'Download Contract Office',

  VIEW_CONTACTS_OFFICE = 'View Contacts Office',
  ADD_CONTACTS_OFFICE = 'Add Contacts Office',
  EDIT_CONTACTS_OFFICE = 'Edit Contacts Office',
  DELETE_CONTACTS_OFFICE = 'Delete Contacts Office',

  VIEW_FILES_OFFICE = 'View File Office',
  UPLOAD_FILES_OFFICE = 'Upload File Office',
  EDIT_FILES_OFFICE = 'Edit File Office',
  DELETE_FILES_OFFICE = 'Delete File Office',
  DOWNLOAD_FILES_OFFICE = 'Download File Office',

  VIEW_NOTE_OFFICE = 'View Note Office',
  ADD_NOTE_OFFICE = 'Add Note Office',
  EDIT_NOTE_OFFICE = 'Edit Note Office',
  DELETE_NOTE_OFFICE = 'Delete Note Office',

  //Project
  VIEW_PROJECT = 'View Project',
  ADD_PROJECT = 'Add Project',
  EDIT_PROJECT = 'Edit Project',
  //DELETE_PROJECT = 'Delete Project',

  VIEW_SERVICE_PROJECT = 'View Service Project',
  ADD_SERVICE_PROJECT = 'Add Service Project',
  DELETE_SERVICE_PROJECT = 'Delete Service Project',
  EDIT_SREVICE_PRICE_PROJECT = 'Edit Service Price Project',

  VIEW_CONTACTS_PROJECT = 'View Contacts Project',
  ADD_CONTACTS_PROJECT = 'Add Contacts Project',
  EDIT_CONTACTS_PROJECT = 'Edit Contacts Project',
  DELETE_CONTACTS_PROJECT = 'Delete Contacts Project',

  VIEW_FILES_PROJECT = 'View File Project',
  UPLOAD_FILES_PROJECT = 'Upload File Project',
  EDIT_FILES_PROJECT = 'Edit File Project',
  DELETE_FILES_PROJECT = 'Delete File Project',
  DOWNLOAD_FILES_PROJECT = 'Download File Project',

  VIEW_NOTE_PROJECT = 'View Note Project',
  ADD_NOTE_PROJECT = 'Add Note Project',
  EDIT_NOTE_PROJECT = 'Edit Note Project',
  DELETE_NOTE_PROJECT = 'Delete Note Project',

  COMPLETE_PROJECT = 'Complete Project',

  //Unit
  VIEW_UNIT = 'View Unit',
  ADD_UNIT = 'Add Unit',
  EDIT_UNIT = 'Edit Unit',
  DELETE_UNIT = 'Delete Unit',

  VIEW_SERVICE_UNIT = 'View Service Unit',

  VIEW_CONTACTS_UNIT = 'View Contacts Unit',
  ADD_CONTACTS_UNIT = 'Add Contacts Unit',
  EDIT_CONTACTS_UNIT = 'Edit Contacts Unit',
  DELETE_CONTACTS_UNIT = 'Delete Contacts Unit',

  VIEW_FILES_UNIT = 'View File Unit',
  UPLOAD_FILES_UNIT = 'Upload File Unit',
  EDIT_FILES_UNIT = 'Edit File Unit',
  DELETE_FILES_UNIT = 'Delete File Unit',
  DOWNLOAD_FILES_UNIT = 'Download File Unit',

  VIEW_NOTE_UNIT = 'View Note Unit',
  ADD_NOTE_UNIT = 'Add Note Unit',
  EDIT_NOTE_UNIT = 'Edit Note Unit',
  DELETE_NOTE_UNIT = 'Delete Note Unit',

  COMPLETE_UNIT = '  Complete Unit',
  GENERATE_COC = 'Generate COC',

  //Work order
  VIEW_WORKORDER = 'View Work Order',
  ADD_WORKORDER = 'Add Work Order',
  EDIT_WORKORDER = 'Edit Work Order',
  DELETE_WORKORDER = 'Delete Work Order',
  SCHEDULE_WORKORDER = 'Schedule Work Order',
  CANCEL_WORKORDER = 'Cancel Work Order',
  UPDATE_STATUS_WORKORDER = 'Update Work Order Status',
  OVERRIDE = 'Override',
  FEE_WAIVING = 'Fee waiving',

  VIEW_CONTACTS_WORKORDER = 'View Contacts Work Order',
  ADD_CONTACTS_WORKORDER = 'Add Contacts Work Order',
  EDIT_CONTACTS_WORKORDER = 'Edit Contacts Work Order',
  DELETE_CONTACTS_WORKORDER = 'Delete Contacts Work Order',

  VIEW_FILES_WORKORDER = 'View File Work Order',
  UPLOAD_FILES_WORKORDER = 'Upload File Work Order',
  EDIT_FILES_WORKORDER = 'Edit File Work Order',
  DELETE_FILES_WORKORDER = 'Delete File Work Order',
  DOWNLOAD_FILES_WORKORDER = 'Download File Work Order',

  VIEW_NOTE_WORKORDER = 'View Note Work Order',
  ADD_NOTE_WORKORDER = 'Add Note Work Order',
  EDIT_NOTE_WORKORDER = 'Edit Note Work Order',
  DELETE_NOTE_WORKORDER = 'Delete Note Work Order',

  VIEW_PO_WORKORDER = 'View Purchase Order Work Order',
  UPLOAD_PO_WORKORDER = 'Upload Purchase Order Work Order',
  EDIT_PO_WORKORDER = 'Edit Purchase Order Work Order',
  DELETE_PO_WORKORDER = 'Delete Purchase Order Work Order',
  DOWNLOAD_PO_WORKORDER = 'Download Purchase Order Work Order',
  EDIT_INSPECTION_REPORT = 'Edit Inspection Report',
  //Plan
  VIEW_PLAN = 'View Plan',
  ADD_PLAN = 'Add Plan',
  EDIT_PLAN = 'Edit Plan',
  DELETE_PLAN = 'Delete Plan',

  //Plan Review Dashboard
  VIEW_PLAN_REVIEW_DASHBOARD = 'View Plan Reviews',
  VIEW_ENERGY_MODELING_DASHBOARD = 'Energy Modeling',
  EDIT_ENERGY_MODELING_DASHBOARD = 'Edit Energy Modeling',
  DELETE_ENERGY_MODELING_DASHBOARD = 'Delete Energy Modeling',
  VIEW_HVAC_DESIGN_ANALYSIS_DASHBOARD = 'HVAC Design Analysis',
  EDIT_HVAC_DESIGN_ANALYSIS_DASHBOARD = 'Edit HVAC Design Analysis',
  DELETE_HVAC_DESIGN_ANALYSIS_DASHBOARD = 'Delete HVAC Design Analysis',
  VIEW_FILE_PROCESSING_DASHBOARD = 'File Processing',
  EDIT_FILE_PROCESSING_DASHBOARD = 'Edit File Processing',
  DELETE_FILE_PROCESSING_DASHBOARD = 'Delete File Processing',
  VIEW_REPORT_DASHBOARD = 'Report Processing',
  EDIT_REPORT_DASHBOARD = 'Edit Report Processing',
  DELETE_REPORT_DASHBOARD = 'Delete Report Processing',
  VIEW_REBATE_DASHBOARD = 'Rebate Processing',
  EDIT_REBATE_DASHBOARD = 'Edit Rebate Processing',
  DELETE_REBATE_DASHBOARD = 'Delete Rebate Processing',
  VIEW_PRIVATE_PROVIDER_PLAN_REVIEW_DASHBOARD = 'Private Provider Plan Review',
  EDIT_PRIVATE_PROVIDER_PLAN_REVIEW_DASHBOARD = 'Edit Private Provider Plan Review',
  DELETE_PRIVATE_PROVIDER_PLAN_REVIEW_DASHBOARD = 'Delete Private Provider Plan Review',

  //Operations Management
  VIEW_OPERATIONMANAGEMENT = 'View Operation Management',
  EDIT_OPERATIONMANAGEMENT = 'Edit Operation Management',

  //Inspector Calendar
  //VIEW_INSPECTOR_CALENDAR = 'View Inspector Calendar',
  VIEW_ALL_CALENDAR = 'Show All Inspectors Calendar',
  VIEW_OWN_CALENDAR = 'Show Own Calendar',
  VIEW_TEAM_CALENDAR = 'Show Team Calendar',

  //Bulk Scheduling
  VIEW_BULKSCHEDULING = 'View Bulk Scheduling',
  BULKSCHEDULE_INSPECTIONS = 'Bulk Schedule Inspections',

  VIEW_SCHEDULEBALANCING = 'View Schedule Balancing',
  MANAGE_SCHEDULEBALANCING = 'Manage Schedule Balancing',

  //Leave Management
  VIEW_LEAVE = 'View Leave',
  ADD_LEAVE = 'Add Leave',
  EDIT_LEAVE = 'Edit Leave',
  DELETE_LEAVE = 'Delete Leave',
  APPROVE_LEAVE = 'Approve Leave',
  REJECT_LEAVE = 'Reject Leave',

  //General
  DOWNLOAD_GRID = 'Download Grid',
  DOWNLOAD_GRID_PDF = 'Download Grid PDF',

  //Files
  VIEW_FILES = 'View File',
  UPLOAD_FILE = 'Upload File',
  DOWNLOAD_FILE = 'Download File',
  EDIT_FILE = 'Edit File',
  DELETE_FILE = 'Delete File',

  //Reports
  VIEW_WORKORDER_REPORTS = 'Work Order Reports',
  VIEW_WORKORDER_REPORT_V2 = 'Work Order Report V2',

  VIEW_INVOICE_REPORTS = 'Invoice Reports',
  VIEW_DUX_INSPECTION_REQUESTS = 'DUX Inspection Requests',
  VIEW_COC_REPORT = 'COC Report',
  //VIEW_Query_Builder = 'Query Builder',

  //Work Order Inspection Report

  VIEW_ALL_INSPECTIONS = 'Show All Inspections',
  VIEW_OWN_INSPECTIONS = 'Show Own Inspections',

  //Invoice Exception Report
  VIEW_INVOICE_EXCEPTION_REPORTS = 'View Invoice Exception Report',
  RETRY_INVOICE_GENERATION = 'Retry Invoice Generation',
  EDIT_INVOICEAMOUNT = 'Edit Invoice Amount',
  REMOVE_WORKORDER_INVOICE_EXCEPTION_REPORT = 'Remove Work Order From Invoice Exception Report',

  //Custom Report
  VIEW_CUSTOM_REPORT = 'View Custom Report',
  RUN_QUERY_CUSTOM_REPORT = 'Run Query',
  SAVE_QUERY_CUSTOM_REPORT = 'Save Query',
  EDIT_QUERY_CUSTOM_REPORT = 'Edit Query',
  DELETE_QUERY_CUSTOM_REPORT = 'Delete Query',

  //Bundles
  VIEW_SERVICE_BUNDLE = 'View Service Bundle',
  ADD_SERVICE_BUNDLE = 'Add Service Bundle',
  EDIT_SERVICE_BUNDLE = 'Edit Service Bundle',
  DELETE_SERVICE_BUNDLE = 'Delete Service Bundle',

  //Masters
  VIEW_MASTER = 'View Master',
  // ADD_MASTER = 'Add Master',
  // EDIT_MASTER = 'Edit Master',
  // DELETE_MASTER = 'Delete Master',

  //Market Area
  VIEW_MARKET_AREA = 'View Market Area',
  ADD_MARKET_AREA = 'Add Market Area',
  EDIT_MARKET_AREA = 'Edit Market Area',
  DELETE_MARKET_AREA = 'Delete Market Area',

  //Municipality
  VIEW_MUNICIPALITY = 'View Municipality',
  ADD_MUNICIPALITY = 'Add Municipality',
  EDIT_MUNICIPALITY = 'Edit Municipality',
  DELETE_MUNICIPALITY = 'Delete Municipality',

  //Service
  VIEW_SERVICE = 'View Service',
  ADD_SERVICE = 'Add Service',
  EDIT_SERVICE = 'Edit Service',
  DELETE_SERVICE = 'Delete Service',

  //Skill Set
  VIEW_SKILLSET = 'View Skill Set',
  ADD_SKILLSET = 'Add Skill Set',
  EDIT_SKILLSET = 'Edit Skill Set',
  DELETE_SKILLSET = 'Delete Skill Set',

  //Role
  VIEW_ROLE = 'View Role',
  ADD_ROLE = 'Add Role',
  EDIT_ROLE = 'Edit Role',
  DELETE_ROLE = 'Delete Role',

  //Employee
  VIEW_EMPLOYEE = 'View Employee',
  ADD_EMPLOYEE = 'Add Employee',
  EDIT_EMPLOYEE = 'Edit Employee',
  DELETE_EMPLOYEE = 'Delete Employee',
  CHANGE_EMPLOYEE_PASSWORD = 'Change Employee Password',

  //Equipment
  VIEW_EQUIPMENT = 'View Equipment',
  ADD_EQUIPMENT = 'Add Equipment',
  EDIT_EQUIPMENT = 'Edit Equipment',
  DELETE_EQUIPMENT = 'Delete Equipment',

  //Division
  VIEW_DIVISION = 'View Division',
  ADD_DIVISION = 'Add Division',
  EDIT_DIVISION = 'Edit Division',
  DELETE_DIVISION = 'Delete Division',

  //Service Category
  VIEW_SERVICECATEGORY = 'View Service Category',
  ADD_SERVICECATEGORY = 'Add Service Category',
  EDIT_SERVICECATEGORY = 'Edit Service Category',
  DELETE_SERVICECATEGORY = 'Delete Service Category',

  //Service Group
  VIEW_SERVICEGROUP = 'View Service Group',
  ADD_SERVICEGROUP = 'Add Service Group',
  EDIT_SERVICEGROUP = 'Edit Service Group',
  DELETE_SERVICEGROUP = 'Delete Service Group',

  //Service Type
  VIEW_SERVICETYPE = 'View Service Type',
  ADD_SERVICETYPE = 'Add Service Type',
  EDIT_SERVICETYPE = 'Edit Service Type',
  DELETE_SERVICETYPE = 'Delete Service Type',

  //Rebate Company
  VIEW_REBATECOMPANY = 'View Rebate Company',
  ADD_REBATECOMPANY = 'Add Rebate Company',
  EDIT_REBATECOMPANY = 'Edit Rebate Company',
  DELETE_REBATECOMPANY = 'Delete Rebate Company',

  //Project Subtype
  VIEW_PROJECTSUBTYPE = 'View Project Subtype',
  ADD_PROJECTSUBTYPE = 'Add Project Subtype',
  EDIT_PROJECTSUBTYPE = 'Edit Project Subtype',
  DELETE_PROJECTSUBTYPE = 'Delete Project Subtype',

  //Contact
  VIEW_CONTACT = 'View Contact',
  ADD_CONTACT = 'Add Contact',
  EDIT_CONTACT = 'Edit Contact',
  DELETE_CONTACT = 'Delete Contact',
  VIEW_MOVE_CONTACT = 'Move Contact',

  //Audit Log
  VIEW_AUDITLOG = 'View Audit Log',

  //Email Log
  VIEW_EMAILLOG = 'View Email Log',

  //DUX
  SYNC_WITH_DUX = 'Sync With DUX',

  //Display Profile
  DISPLAY_PROFILE = 'Display Profile',

  //Department
  VIEW_DEPARTMENT = 'View Department',
  ADD_DEPARTMENT = 'Add Department',
  EDIT_DEPARTMENT = 'Edit Department',
  DELETE_DEPARTMENT = 'Delete Department',

  //Notes
  VIEW_NOTE = 'View Notes',
  ADD_NOTE = 'Add Notes',
  EDIT_NOTE = 'Edit Notes',
  DELETE_NOTE = 'Delete Notes',

  //Read Only
  READ_ONLY = 'Read Only',

  //Reinspection Exception Report
  REINSPECTION_EXCEPTION_REPORT = 'Reinspection Exception Report',
  EDIT_REINSPECTION_EXCEPTION_REPORT = 'Edit Reinspection Exception Report',

  //Set Active-Inactive
  SET_ACTIVE_INACTIVE = 'Set Active-Inactive',

  //Quickbook Service
  VIEW_QB_SERVICE_MAPPING = 'Show QuickBooks Service Mapping',
  SET_QB_SERVICE_MAPPING = 'Set QuickBooks Service Mapping',

  //Pricing List
  ADD_PRICING_LIST = 'Add Pricing List',
  EDIT_PRICING_LIST = 'Edit Pricing List',
  OVERRIDE_PRICING_LIST = 'Override Pricing List',

  //Project Request
  VIEW_REQUESTS = 'View Requests',

  //Associated Service Group
  MANAGE_EMPLOYEE_SKILLSET_PRIMARY_LICENSE = 'Manage Employee Skillset Primary License',

  //Service Municipality
  ADD_SERVICE_MUNICIPALITY_MAPPING = 'Add Service Municipality Mapping',
  EDIT_SERVICE_MUNICIPALITY_MAPPING = 'Edit Service Municipality Mapping',

  //Holiday
  VIEW_HOLIDAY = 'View Holiday',
  ADD_HOLIDAY = 'Add Holiday',
  EDIT_HOLIDAY = 'Edit Holiday',
  DELETE_HOLIDAY = 'Delete Holiday',
  WEEKEND_HOLIDAY_SCHEDULING_OVERRIDE = 'Weekend Holiday Scheduling Override',
}
